export default __webpack_public_path__ + "static/media/ellipse_233.db1ea83a.png";